module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-cell"
  }, [_c('p', {
    staticClass: "game-name"
  }, [_vm._v(_vm._s(_vm.cellData.name))]), _vm._v(" "), _c('p', {
    staticClass: "game-players"
  }, _vm._l((_vm.cellData.players), function(player, indexPlayer) {
    return _c('span', {
      class: {
        'winner': indexPlayer === _vm.cellData.winnerID
      }
    }, [_vm._v(_vm._s(player.name))])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78346d7e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GameCell.vue
// module id = 115
// module chunks = 2